<template>
  <v-app-bar color="primary" height="30" max-height="30" dark>
    <template v-slot:default>
      <slot name="default">
        <app-bar-button
          v-bind:disabled="state.isUndoTargetEmpty"
          v-on:click.stop="callback.undoChange"
        >
          <v-icon>mdi-undo</v-icon>Undo
        </app-bar-button>

        <app-bar-button
          v-bind:disabled="state.isRedoTargetEmpty"
          v-on:click.stop="callback.redoChange"
        >
          <v-icon>mdi-redo</v-icon>Redo
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.createNewScattData">
          <v-icon>mdi-file</v-icon>New
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.loadVideoDataFromLocalFile({ generatesWaveformDigestData: true })">
          <v-icon>mdi-movie-open</v-icon>Load
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.loadScattDataFromLocalFile">
          <v-icon>mdi-import</v-icon>Import
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.downloadScattData">
          <v-icon>mdi-export</v-icon>Export
        </app-bar-button>

        <app-bar-button
          v-bind:disabled="state.isCurrentScattDataSameAsLastSaved"
          v-on:click.stop="callback.saveScattData"
        >
          <v-icon>mdi-content-save</v-icon>Save
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.showViewFilter">
          <v-icon>mdi-format-list-checkbox</v-icon>Filter view
        </app-bar-button>

        <app-bar-button v-on:click.stop="callback.showHelp">
          <v-icon>mdi-help-circle</v-icon>Help
        </app-bar-button>
      </slot>
    </template>
  </v-app-bar>
</template>

<script>
import AppBarButton from './AppBar/AppBarButton.vue';

export default {
  components: {
    AppBarButton,
  },

  props: {
    state:    { type: Object },
    callback: { type: Object },
  },
}
</script>